import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FaMinusCircle } from 'react-icons/fa';
export const removeAssignmentCssStyle = css `
  .remove-assignment {
    visibility: hidden;
  }

  &:hover {
    .remove-assignment {
      visibility: visible;
    }
  }
`;
export function RemoveAssignmentsButton({ onClick }) {
    return (_jsx("sup", { className: "remove-assignment", children: _jsx("button", { type: "button", style: {
                padding: 0,
                margin: 0,
            }, onClick: onClick, children: _jsx(FaMinusCircle, { color: "red" }) }) }));
}
